import { DebitOrCreditEnum } from "@/lib/enum/debit-or-credit.enum";
import { FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { IVSelectItem } from "@/lib/interfaces/v-select-item.interface";
import { ThgAccountingRecordItemDtoGen } from "@/services/thg/v1/data-contracts";

@IsFilterable
export class AccountingRecordItemBase implements ThgAccountingRecordItemDtoGen {
  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "Amount"
  })
  amount: number;

  @FilterConfig({
    type: FilterTypes.ENUM,
    config: {
      items: Object.values(DebitOrCreditEnum).map((v) => {
        return {
          text: `enums.DebitOrCreditEnum.${v}`,
          value: v
        } as IVSelectItem;
      }),
      itemValue: "value"
    },
    displayName: "Billing Type"
  })
  debitOrCredit: DebitOrCreditEnum;

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "account"
  })
  account: number;

  @FilterConfig({
    type: FilterTypes.NUMBER,
    displayName: "contraAccount"
  })
  contraAccount: number;

  @FilterConfig({
    type: FilterTypes.STRING,
    displayName: "bookingText"
  })
  bookingText: string;

  constructor(accountingRecordItem: Partial<ThgAccountingRecordItemDtoGen>) {
    this.amount = accountingRecordItem?.amount ?? 0;
    this.debitOrCredit = (accountingRecordItem?.debitOrCredit as DebitOrCreditEnum) ?? DebitOrCreditEnum.CREDIT;
    this.account = accountingRecordItem?.account ?? 0;
    this.contraAccount = accountingRecordItem?.contraAccount ?? 0;
    this.bookingText = accountingRecordItem?.bookingText ?? "";
  }
}

// not configured well in backend. Make searchable in backend to enable this
// export const AccountingRecordItem = Filter.createForClass(AccountingRecordItemBase);
export const AccountingRecordItem = AccountingRecordItemBase;
